module.exports = __webpack_public_path__ + "static/media/logoWOtext.c1bd46b0.svg";